export default __webpack_public_path__ + "images/b757eb69211c77b9f94008270b56d9a7.svg";